//русский

import cryptoproCert from "./Cert";

export { cryptoproCert };
